module.exports = __webpack_public_path__ + "angular/components/authentication/login-d5e5ba84.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/authentication/login.html
// module id = 21
// module chunks = 0